module.exports = __webpack_public_path__ + "static/lubella-8c24fe2f329db67aa5be65a418993814.png";